// Üst şeritte ve /lptrax sağ rayında görünen AKTİF bot listesi — tek kaynak.
//
// Eskiden bu liste App.tsx içinde `PRIMARY_BOT_IDS` olarak elle tutuluyordu;
// /lptrax standalone render edildiği (Router'a hiç girmediği) için oraya
// erişemiyordu. Buraya taşındı: App şeridi id'leri buradan alıyor, LP Trax
// rayı da aynı listeyi ad'larıyla basıyor → ikisi asla ayrışmıyor.
//
// `name` burada DURUYOR çünkü /lptrax açılışında `botList` henüz WS'ten gelmiş
// olmuyor; etiketi beklemeden basmak gerekiyor. Yeni bot eklerken BotSelectOverlay
// içindeki kart tanımına da yazmak şart (o liste de elle tutuluyor).
export const ACTIVE_BOTS: { id: string; name: string }[] = [
  { id: 'Sol - Timur Bey',    name: 'Sol - Timur Bey' },
  { id: 'Bluefin - LP',       name: 'Bluefin - LP' },
  { id: 'Bluefin - Backpack', name: 'Bluefin - Backpack' },
  { id: 'Extended',           name: 'Extended' },
  { id: 'binance1',           name: 'Binance Futures' },
  { id: 'dydx-main',          name: 'dYdX Perps' },
  { id: 'Hyperliquid',        name: 'Hyperliquid' },
  { id: 'aster1',             name: 'AsterDex' },
  { id: 'lighter',            name: 'Lighter' },
  { id: 'KuCoin',             name: 'KuCoin' },
];

// /lptrax'ten bir bota geçişte kullanılan devir anahtarı. LP Trax ayrı bir
// kök (Router yok) olduğu için düğme yönlendirmeyi `/`'ye yapıyor; App açılışta
// bu anahtarı OKUYUP SİLİYOR ve bot seçim ekranını atlayarak doğrudan o bota
// giriyor (bkz. App.tsx'teki tek-seferlik effect).
export const PENDING_BOT_KEY = 'rt_pending_bot';
